<div id="product-page" class="wrapper-inner">
  <div class="main-content">
    <ng-container
      *ngTemplateOutlet="
        mobileDevice ? mobileView : tabletDevice ? tableView : desktopView
      "
    ></ng-container>
  </div>
</div>

<ng-template #desktopView>
  <div class="order-settings__subnav container font-5 my-3">
    <div class="row px-0">
      <app-cart-select [allowAdd]="true"></app-cart-select>

      @if (activeOrder && canShowOrderSettings) {
        <span class="right sap-title">
          <button
            id="btn-edit-order-info"
            class="m-lg-1 btn btn-outline-primary"
            (click)="editOrderSettings()"
            title="Edit"
          >
            EDIT ORDER INFO
          </button>
        </span>
      }
    </div>
  </div>

  <!-- product detail page -->
  @if (heroSlides) {
    <app-hero [slides]="heroSlides"></app-hero>
  }
  <app-breadcrumb></app-breadcrumb>

  @if (product) {
    <div id="product-details-container" class="product-details container">
      <div class="product-details__upper">
        <div id="product-gallery-wrapper" class="product-details--gallery">
          <product-gallery [product]="product"></product-gallery>
        </div>
        <div class="product-details--options">
          @if (activeOrder) {
            <app-product-order-item
              viewType="detailed"
              [product]="product"
              [order]="activeOrder"
              [showBudget]="true"
              (changed)="onOrderItemChanged($event)"
            >
            </app-product-order-item>
          }
        </div>
      </div>
      <div class="product-details__lower">
        <product-details [product]="product"></product-details>
      </div>
      @if (relatedPids && products.length > 0) {
        <div id="product-related" class="product-details__related">
          <products-grid-related
            [products]="products"
            [order]="activeOrder"
          ></products-grid-related>
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #mobileView>
  <div class="container">
    <div class="order-settings__subnav font-5 my-3">
      <div class="d-flex align-items-center justify-content-between">
        <app-cart-select [allowAdd]="true" [mobile]="true"></app-cart-select>

        @if (activeOrder && canShowOrderSettings) {
          <span class="right sap-title">
            <button
              class="btn btn-icon with-shadow with-border btn-order-edit"
              (click)="editOrderSettings()"
              title="Edit"
            >
              <i class="fal fa-edit"></i>
            </button>
          </span>
        }
      </div>
    </div>

    @if (product) {
      <div class="d-md-block">
        <h1
          class="product-label color--primary-blue my-0"
          [innerHTML]="product.label | safeContent"
        ></h1>
      </div>
      <!-- product detail page -->
      @if (product) {
        <div class="product-details mt-3">
          <div class="product-details__upper">
            <div class="product-details--gallery mx-auto mb-3">
              <product-gallery [product]="product"></product-gallery>
            </div>
            <div
              class="product-details--options line-up-separator--light-grey pt-3"
            >
              @if (activeOrder) {
                <app-product-order-item
                  viewType="detailed"
                  [product]="product"
                  [order]="activeOrder"
                  [showBudget]="true"
                  (changed)="onOrderItemChanged($event)"
                >
                </app-product-order-item>
              }
            </div>
          </div>
          <div class="product-details__lower">
            <product-details [product]="product"></product-details>
          </div>
          @if (relatedPids && products.length > 0) {
            <div class="product-details__related line-up-separator--grey">
              <products-grid-related
                [products]="products"
                [order]="activeOrder"
              ></products-grid-related>
            </div>
          }
        </div>
      }
    }
  </div>
</ng-template>

<ng-template #tableView>
  <div class="container">
    <div class="order-settings__subnav font-5 my-3">
      <div class="d-flex align-items-center justify-content-between">
        <app-cart-select [allowAdd]="true" [mobile]="true"></app-cart-select>

        @if (activeOrder && canShowOrderSettings) {
          <span class="right sap-title">
            <button
              class="btn btn-icon with-shadow with-border btn-order-edit"
              (click)="editOrderSettings()"
              title="Edit"
            >
              <i class="fal fa-edit"></i>
            </button>
          </span>
        }
      </div>
    </div>

    <!-- product detail page -->
    @if (product) {
      <div class="product-details mt-3">
        <div class="product-details__upper">
          <div class="product-details--gallery mx-auto">
            <product-gallery [product]="product"></product-gallery>
          </div>
          <div class="product-details--options">
            @if (activeOrder) {
              <app-product-order-item
                viewType="detailed"
                [product]="product"
                [order]="activeOrder"
                [showBudget]="true"
                (changed)="onOrderItemChanged($event)"
              >
              </app-product-order-item>
            }
          </div>
        </div>
        <div class="product-details__lower">
          <product-details [product]="product"></product-details>
        </div>
        @if (relatedPids && products.length > 0) {
          <div class="product-details__related">
            <products-grid-related
              [products]="products"
              [order]="activeOrder"
            ></products-grid-related>
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<app-footer></app-footer>
<app-back-top [position]="200"></app-back-top>
